var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-table',{staticClass:"skeleton-table",attrs:{"data":_vm.fake,"hoverable":false,"striped":false}},_vm._l((_vm.columns),function(column){return _c('b-table-column',{key:column.field,attrs:{"field":column.field,"label":column.label}},[_c('b-skeleton')],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }